import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FaTachometerAlt,
  FaUser,
  FaUsers,
  FaChartBar,
  FaChevronCircleDown,
  FaProjectDiagram,
  FaTasks,
  FaBars,
  FaTimes,
} from "react-icons/fa";
import "./CSS/Sidebar.css";
import { FaTimeline } from "react-icons/fa6";
import { useUser } from "./Context/UserContext.tsx";
const Sidebar: React.FC = () => {
  const location = useLocation();
  const [isReportsOpen, setReportsOpen] = useState(() => location.pathname.startsWith("/admin-dashboard/detailsReport") || location.pathname.startsWith("/admin-dashboard/summaryreport"));
  const [isTaskOpen, setTaskOpen] = useState(() => location.pathname.startsWith("/admin-dashboard/AddTask") || location.pathname.startsWith("/admin-dashboard/TaskList"));
  const [isMobileOpen, setMobileOpen] = useState(false);
  const { user } = useUser();

  const toggleReportsDropdown = () => setReportsOpen(!isReportsOpen);
  const toggleTaskDropdown = () => setTaskOpen(!isTaskOpen);
  const closeMobile = () => setMobileOpen(false);

  const isActive = (path: string) => location.pathname.startsWith(path);
  const reportsRouteActive = isActive("/admin-dashboard/detailsReport") || isActive("/admin-dashboard/summaryreport");
  const taskRouteActive = isActive("/admin-dashboard/AddTask") || isActive("/admin-dashboard/TaskList");

  useEffect(() => {
    if (reportsRouteActive) setReportsOpen(true);
    if (taskRouteActive) setTaskOpen(true);
  }, [reportsRouteActive, taskRouteActive]);

  return (
    <>
      <button
        type="button"
        className="sidebar-toggle"
        aria-label={isMobileOpen ? "Close menu" : "Open menu"}
        onClick={() => setMobileOpen(!isMobileOpen)}
      >
        {isMobileOpen ? <FaTimes /> : <FaBars />}
      </button>
      {isMobileOpen && (
        <div className="sidebar-backdrop" onClick={closeMobile}></div>
      )}
      <div className={`sidebar${isMobileOpen ? " sidebar-open" : ""}`}>
      <div className="logo">
        <h2>{user?.isadmin ? "Admin Panel" : "User Panel"}</h2>
      </div>
      <ul className="nav-links" onClick={(e) => {
        const target = e.target as HTMLElement;
        if (target.closest("a") && !target.closest(".dropdown-toggle")) {
          closeMobile();
        }
      }}>
        {/* This is visible to both admin and user */}

        {/* Admin-only links */}
        {user?.isadmin ? (
          <>
            <li>
              <Link
                to="/admin-dashboard/activity-dashboard"
                className={isActive("/admin-dashboard/activity-dashboard") ? "active" : ""}
              >
                <FaTachometerAlt className="icon" /> Dashboard
              </Link>
            </li>
            <li>
              <Link
                to="/admin-dashboard/timeline"
                className={isActive("/admin-dashboard/timeline") ? "active" : ""}
              >
                <FaTimeline className="icon" /> TimeLine
              </Link>
            </li>
            <li>
              <Link
                to="/admin-dashboard/team"
                className={isActive("/admin-dashboard/team") ? "active" : ""}
              >
                <FaUsers className="icon" /> Team
              </Link>
            </li>
            <li>
              <button
                type="button"
                className={`dropdown-toggle nav-dropdown-trigger${isReportsOpen ? " open" : ""}${reportsRouteActive ? " active" : ""}`}
                onClick={toggleReportsDropdown}
                aria-expanded={isReportsOpen}
              >
                <FaChartBar className="icon" /> Reports
                <FaChevronCircleDown className="icon chevron" />
              </button>
              {isReportsOpen && (
                <ul className="dropdown">
                  <li>
                    <Link to="/admin-dashboard/detailsReport" className={isActive("/admin-dashboard/detailsReport") ? "active" : ""}>
                      <FaChartBar className="icon" /> Details Report
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin-dashboard/summaryreport" className={isActive("/admin-dashboard/summaryreport") ? "active" : ""}>
                      <FaChartBar className="icon" /> Summary Report
                    </Link>
                  </li>
                </ul>
              )}
            </li>
            <li>
              <Link
                to="/admin-dashboard/project"
                className={isActive("/admin-dashboard/project") ? "active" : ""}
              >
                <FaProjectDiagram className="icon" /> Project
              </Link>
            </li>
            <li>
              <Link
                to="/admin-dashboard/client"
                className={isActive("/admin-dashboard/client") ? "active" : ""}
              >
                <FaUser className="icon" /> Client
              </Link>
            </li>
            <li>
              <button
                type="button"
                className={`dropdown-toggle nav-dropdown-trigger${isTaskOpen ? " open" : ""}${taskRouteActive ? " active" : ""}`}
                onClick={toggleTaskDropdown}
                aria-expanded={isTaskOpen}
              >
                <FaTasks className="icon" /> Task
                <FaChevronCircleDown className="icon chevron" />
              </button>
              {isTaskOpen && (
                <ul className="dropdown">
                  <li>
                    <Link to="/admin-dashboard/AddTask" className={isActive("/admin-dashboard/AddTask") ? "active" : ""}>
                      <FaTasks className="icon" /> Add Task
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin-dashboard/TaskList" className={isActive("/admin-dashboard/TaskList") ? "active" : ""}>
                      <FaTasks className="icon" /> Task List
                    </Link>
                  </li>
                </ul>
              )}
            </li>
          </>
        ) : (
          <>
            {/* User-only link example */}
            <li>
              <Link
                to="/User-dashboard/UserprojectList"
                className={isActive("/User-dashboard/UserprojectList") ? "active" : ""}
              >
                <FaProjectDiagram className="icon" />
                User Dashboard
              </Link>
            </li>
            <li>
              <Link
                to="/User-dashboard/UserTaskList"
                className={isActive("/User-dashboard/UserTaskList") ? "active" : ""}
              >
                <FaTasks className="icon" />
                Task List
              </Link>
            </li>
          </>
        )}

        {/* Settings visible to both */}
      </ul>
      </div>
    </>
  );
};
export default Sidebar;
